import { useState, useEffect, useCallback } from 'react';
import type { Review } from '@segmently/schema-models/entities';
import { ReviewService } from '@modules/firebase-core/services/ReviewService';

export function useReviews(projectId: string) {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    setError('');

    const service = new ReviewService(projectId);
    const unsub = service.subscribe(
      (data) => { setReviews(data); setLoading(false); },
      (err) => { console.error('Error listening reviews:', err); setError('Failed to load reviews.'); setLoading(false); },
    );
    return () => unsub();
  }, [projectId]);

  const createReview = useCallback(async (data: Partial<Review>) => {
    const service = new ReviewService(projectId);
    return service.create(data);
  }, [projectId]);

  const updateReview = useCallback(async (id: string, data: Partial<Review>) => {
    const service = new ReviewService(projectId);
    return service.update(id, data);
  }, [projectId]);

  const deleteReview = useCallback(async (id: string) => {
    const service = new ReviewService(projectId);
    return service.delete(id);
  }, [projectId]);

  return { reviews, loading, error, setError, createReview, updateReview, deleteReview };
}
